import React from "react";
import { Form, Modal } from "react-bootstrap";
import { ReactComponent as Whiteclose } from "../../assets/images/white-close.svg";
import { Backdrop, CircularProgress, Drawer } from "@mui/material";
import { NotificationManager } from "react-notifications";
import validator from "validator";
import { connect } from "react-redux";
import {
  userSignup,
  userSignupFailure,
} from "../../store/signUp/signUp.actions";
import { selectSignUpStatus } from "../../store/signUp/signUp.selectors";
import { selectemployeeData } from "../../store/home/home.selectors";
import { bindActionCreators } from "redux";

const removeExtraSpace = (s) => s.trim().replace(/\s/g, "");
var isNotification = 0;

const mapStateToProps = (state) => {
  return {
    selectSignUpStatus: selectSignUpStatus(state),
    employeeData: selectemployeeData(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      userSignup,
      userSignupFailure,
    },
    dispatch
  ),
});

class RegisterOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: 0,
      username: "",
      email: "",
      // phone: "",
      password: "",
      repeatedPassword: "",

      isRegistrationComplete: false,
    };
  }

  componentDidMount() {
    if (this.props.employeeData?.employeeId != null) {
      this.props.close();
    } else {
      this.setState({
        email: "",
        // phone: "",
        username: "",
        password: "",
        repeatedPassword: "",
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectSignUpStatus, userSignupFailure } = this.props;
    if (isNotification === 1) {
      if (selectSignUpStatus.success != null) {
        if (selectSignUpStatus.success) {
          NotificationManager.success(
            "User Registration Successfully.",
            "",
            2000
          );
          isNotification = 0;
          this.timeoutHandle = setTimeout(() => {
            this.setState({ isLoading: 0, isRegistrationComplete: true });
          }, 3000);
          userSignupFailure({
            signUpSuccess: false,
            loading: false,
            err: null,
          });
        } else {
          if (selectSignUpStatus.error != null) {
            if (selectSignUpStatus.error !== "") {
              NotificationManager.error(selectSignUpStatus.error, "", 2000);
              isNotification = 0;
              this.timeoutHandle = setTimeout(() => {
                this.setState({
                  isLoading: 0,
                });
              }, 3000);
              userSignupFailure({
                signUpSuccess: false,
                loading: false,
                err: null,
              });
            }
            isNotification = 0;
          }
        }
      }
    }
  }

  handleEmail = (event) => {
    this.setState({ email: removeExtraSpace(event.target.value) });
  };
  // handlePhone = (event) => {
  //   const phoneNumber = event.target.value.replace(/\D/g, "");
  //   let formatted = "";
  //   if (phoneNumber.length > 3) {
  //     formatted += phoneNumber.substr(0, 3) + "-";
  //     if (phoneNumber.length > 6) {
  //       formatted += phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6);
  //     } else {
  //       formatted += phoneNumber.substr(3);
  //     }
  //   } else {
  //     formatted = phoneNumber;
  //   }
  //   this.setState({ phone: formatted });
  // };
  handleUsername = (event) => {
    this.setState({ username: removeExtraSpace(event.target.value) });
  };
  // handleLastName = (event) => {
  //   this.setState({ lastName: removeExtraSpace(event.target.value) });
  // };
  handlePassword = (event) => {
    this.setState({ password: event.target.value });
  };
  handleRepeatedPassword = (event) => {
    this.setState({ repeatedPassword: event.target.value });
  };

  signUp = () => {
    // var pattern = new RegExp(/^[0-9\b]+$/);
    const rule = new RegExp(/^[a-zA-Z ]{2,20}$/);
    // const fNumber = this.state.phone.split("-").join("");
    const { userSignup } = this.props;
    if (this.state.email.trim() === "") {
      NotificationManager.warning("Please Enter Email.", "", 2000);
    } else if (!validator.isEmail(this.state.email)) {
      NotificationManager.warning("Please Enter Valid Email.", "", 2000);
    } else if (this.state.username.trim() === "") {
      NotificationManager.warning("Please Enter User Name.", "", 2000);
    } else if (!rule.test(this.state.username)) {
      NotificationManager.warning(
        "User Name must contains at least two charachers.",
        "",
        2000
      );
      // } else if (fNumber.trim() === "") {
      //   NotificationManager.warning("Please Enter Phone.");
      // } else if (!pattern.test(fNumber)) {
      //   NotificationManager.warning("Please Enter Valid Phone.", "", 2000);
      // } else if (fNumber.length !== 10) {
      //   NotificationManager.warning("Please Enter Valid Phone.", "", 2000);
    } else if (this.state.password === "") {
      NotificationManager.warning("Please Enter Password.", "", 2000);
    } else if (!validator.isStrongPassword(this.state.password)) {
      NotificationManager.warning(
        "Password must contain at least 8 characters, including 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.",
        "",
        2000
      );
    } else if (this.state.repeatedPassword === "") {
      NotificationManager.warning("Please Enter Confirm Password.", "", 2000);
    } else if (this.state.repeatedPassword !== this.state.password) {
      NotificationManager.warning("Password's do not match.", "", 2000);
    } else {
      const payload = {
        email: this.state.email,
        // phone: fNumber,
        name: this.state.username,
        password: this.state.password,
        confirmPassword: this.state.repeatedPassword,
        // confirmPassword: this.state.password,
      };
      isNotification = 1;
      this.setState({ isLoading: 1 });
      userSignup(payload);
    }
  };

  render() {
    return (
      <>
        <Modal
          enforceFocus={false}
          show={this.props.visible}
          onHide={this.props.close}
          backdrop="static"
          keyboard={false}
          centered={true}
          id="signin-modal"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          {this.state.isRegistrationComplete ? (
            <div className="mobile-registration" id="mobile-acc-create">
              <div className="mobile-register">
                <p>Register</p>
                <Whiteclose className="closeicon" onClick={this.props.close} />
              </div>
              <div className="mobile-register-details">
                <img
                  src={require("../../assets/images/electrified-black.png")}
                  alt="logo"
                  className="black-logo"
                ></img>
                <h4>
                  Welcome! <br></br> Account created
                </h4>
                <button
                  onClick={() => {
                    this.setState({
                      isLoading: 0,
                      username: "",
                      email: "",
                      password: "",
                      repeatedPassword: "",

                      isRegistrationComplete: false,
                    });
                    this.props.close();
                    this.props.showSigninOverlay();
                  }}
                  type="button"
                  className="header-mob-btn"
                >
                  Sign in
                </button>
              </div>
            </div>
          ) : (
            <div className="mobile-registration">
              <div className="mobile-register">
                <p>Register</p>
                <Whiteclose className="closeicon" onClick={this.props.close} />
              </div>
              <div className="mobile-register-details" id="web-register">
                <img
                  src={require("../../assets/images/electrified-black.png")}
                  alt="logo"
                  className="black-logo"
                ></img>
                <h4>
                  Join the Electrified Exhibit community to comment or save your
                  favorites!
                </h4>
                <Form.Group>
                  <label className="label">Add email to register</label>
                  <Form.Control
                    type="email"
                    className="register-email"
                    placeholder="email"
                    value={this.state.email}
                    onChange={this.handleEmail}
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <label className="label">Create user name</label>
                  <Form.Control
                    type="text"
                    className="register-email"
                    placeholder="user name"
                    value={this.state.username}
                    onChange={this.handleUsername}
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <label className="label">Create password</label>
                  <Form.Control
                    type="password"
                    className="register-email"
                    placeholder="password"
                    value={this.state.password}
                    onChange={this.handlePassword}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <label className="label">Confirm password</label>
                  <Form.Control
                    type="password"
                    className="register-email"
                    placeholder="confirm password"
                    value={this.state.repeatedPassword}
                    onChange={this.handleRepeatedPassword}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
                <button
                  onClick={this.signUp}
                  type="button"
                  className="header-mob-btn"
                >
                  Register
                </button>
                <button
                  onClick={() => {
                    this.props.close();
                    this.props.showSigninOverlay();
                  }}
                  type="button"
                  className="header-mob-btn"
                  id="signin-btn"
                >
                  Sign in
                </button>
              </div>
            </div>
          )}
        </Modal>

        <Drawer
          anchor="right"
          open={this.props.visible}
          onClose={this.props.close}
          id="set-mob-drawer"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          <div id="togglemenu-mobile">
            <div className="close-icon">
              <Whiteclose
                className="drawerclose-icon"
                onClick={this.props.close}
              />
            </div>
            {this.state.isRegistrationComplete ? (
              <div className="mobile-registration" id="mobile-acc-create">
                <div className="mobile-register">
                  <p>Register</p>
                </div>
                <div className="mobile-register-details">
                  <img
                    src={require("../../assets/images/electrified-black.png")}
                    alt="logo"
                    className="black-logo"
                  ></img>
                  <h4>
                    Welcome! <br></br> Account created
                  </h4>
                  <button
                    onClick={() => {
                      this.props.close();
                      this.props.showSigninOverlay();
                    }}
                    type="button"
                    className="header-mob-btn"
                  >
                    Sign in
                  </button>
                </div>
              </div>
            ) : (
              <div className="mobile-registration">
                <div className="mobile-register">
                  <p>Register</p>
                </div>
                <div className="mobile-register-details">
                  <img
                    src={require("../../assets/images/electrified-black.png")}
                    alt="logo"
                    className="black-logo"
                  ></img>
                  <h4>
                    Join the Electrified Exhibit community to comment or save
                    your favorites!
                  </h4>
                  <Form.Group>
                    <label className="label">add email to register</label>
                    <Form.Control
                      type="email"
                      className="register-email"
                      placeholder="Email"
                      value={this.state.email}
                      onChange={this.handleEmail}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                      autoComplete="off"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <label className="label">create user name</label>
                    <Form.Control
                      type="text"
                      className="register-email"
                      placeholder="User Name"
                      value={this.state.username}
                      onChange={this.handleUsername}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                      autoComplete="off"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <label className="label">create password</label>
                    <Form.Control
                      type="password"
                      className="register-email"
                      placeholder="password"
                      value={this.state.password}
                      onChange={this.handlePassword}
                      autoComplete="off"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <label className="label">confirm password</label>
                    <Form.Control
                      type="password"
                      className="register-email"
                      placeholder="confirm password"
                      value={this.state.repeatedPassword}
                      onChange={this.handleRepeatedPassword}
                      autoComplete="off"
                      required
                    />
                  </Form.Group>
                  <button
                    onClick={this.signUp}
                    type="button"
                    className="header-mob-btn"
                  >
                    Register
                  </button>
                  <button
                    onClick={() => {
                      this.props.close();
                      this.props.showSigninOverlay();
                    }}
                    type="button"
                    className="header-mob-btn"
                    id="signin-btn"
                  >
                    Sign in
                  </button>
                </div>
              </div>
            )}
          </div>
        </Drawer>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterOverlay);
